import {
  OreButton,
  OreCardContainer,
  OreCardWrapper,
  OreDivider,
  OreHeading,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalActions } from '@/Shared/ui/Modal/atoms'
import { DeleteAccountModal } from '@/User/ui/atoms'
import { deleteAccountTranslation } from '@/User/ui/userTranslation'

export const DeleteAccount = (): JSX.Element => {
  const { t } = useTranslation()
  const ref = useRef<ModalActions>(null)

  const handleClick = (): void => {
    ref?.current?.open()
  }

  return (
    <>
      <OreCardContainer>
        <OreCardWrapper space="large">
          <OreHeading as="h2" size="headline-sm">
            {t(deleteAccountTranslation.title)}
          </OreHeading>

          <OreDivider space="medium" />

          <OreStack space="large">
            <OreText>{t(deleteAccountTranslation.description)}</OreText>
            <OreStack>
              <OreButton
                as="button"
                category="primary"
                onClick={handleClick}
                size="large"
                data-testid="deleteAccount"
              >
                {t(deleteAccountTranslation.deleteButton)}
              </OreButton>
            </OreStack>
          </OreStack>
        </OreCardWrapper>
      </OreCardContainer>
      <DeleteAccountModal ref={ref} />
    </>
  )
}
